import {Provider} from '@angular/core';
import {
    CrCustomerHeaderComponent
} from "../component/protected-components/cr-customer/component/cr-customer-header/cr-customer-header.component";
import {
    CrCustomerProfileCheckComponent
} from "../component/protected-components/cr-customer-profile-check/cr-customer-profile-check.component";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    CrCreateCustomerDetailComponent
} from "../component/protected-components/cr-create-customer-detail/cr-create-customer-detail.component";
import {
    CrCreateCustomerEmergencyContactComponent
} from "../component/protected-components/cr-create-customer-emergency-contact/cr-create-customer-emergency-contact.component";
import {
    CrCreateObjectCustomerComponent
} from "../component/protected-components/cr-create-object-customer/cr-create-object-customer.component";
import {CrCustomerComponent} from "../component/protected-components/cr-customer/cr-customer.component";
import {
    CrCustomerAdditionalInformationNavigationComponent
} from "../component/protected-components/cr-customer/component/cr-customer-additional-information-navigation/cr-customer-additional-information-navigation.component";
import {
    CrCustomerAppointmentsComponent
} from "../component/protected-components/cr-customer/component/cr-customer-appointments/cr-customer-appointments.component";
import {
    CrCustomerCommunicationNavigationComponent
} from "../component/protected-components/cr-customer/component/cr-customer-communication-navigation/cr-customer-communication-navigation.component";
import {
    CrCustomerExternalIdsComponent
} from "../component/protected-components/cr-customer/component/cr-customer-external-ids/cr-customer-external-ids.component";
import {
    CrCustomerInteractionNavigationComponent
} from "../component/protected-components/cr-customer/component/cr-customer-interaction-navigation/cr-customer-interaction-navigation.component";
import {
    CrCustomerPromoComponent
} from "../component/protected-components/cr-customer/component/cr-customer-promo/cr-customer-promo.component";
import {
    CrCustomerRegistrationNavigationComponent
} from "../component/protected-components/cr-customer/component/cr-customer-registration-navigation/cr-customer-registration-navigation.component";
import {
    CrCustomerStandardNavigationComponent
} from "../component/protected-components/cr-customer/component/cr-customer-standard-navigation/cr-customer-standard-navigation.component";
import {
    CrCustomerCommentsComponent
} from "../component/protected-components/cr-customer-comments/cr-customer-comments.component";
import {
    CrCustomerContractDetailsComponent
} from "../component/protected-components/cr-customer-contract-details/cr-customer-contract-details.component";
import {
    CrCustomerDocumentUploadComponent
} from "../component/protected-components/cr-customer-document-upload/cr-customer-document-upload.component";
import {
    CrCustomerInlineComponent
} from "../component/protected-components/cr-customer-inline-component/cr-customer-inline-component";
import {
    CrCustomerInteractionInlineComponent
} from "../component/protected-components/cr-customer-interaction-inline-component/cr-customer-interaction-inline-component";
import {
    CrCustomerInteractionObjectComponent
} from "../component/protected-components/cr-customer-interaction-object-component/cr-customer-interaction-object.component";
import {
    CrCustomerPhoneContactAvailabilityComponent
} from "../component/protected-components/cr-customer-phone-contact-availability/cr-customer-phone-contact-availability.component";
import {
    CrCustomerRelatedPersonComponent
} from "../component/protected-components/cr-customer-related-person/cr-customer-related-person.component";
import {
    CrManageRegistrationDocumentComponent
} from "../component/protected-components/cr-manage-registration/cr-manage-registration-document/cr-manage-registration-document.component";
import {
    CrRegistrationToolingTicketViewerComponent
} from "../component/protected-components/cr-manage-registration/cr-manage-registration-tooling-area/components/registration-tooling-ticket-viewer/cr-registration-tooling-ticket-viewer.component";
import {
    CrManageRegistrationToolingAreaComponent
} from "../component/protected-components/cr-manage-registration/cr-manage-registration-tooling-area/cr-manage-registration-tooling-area.component";
import {
    CrManageRegistrationUserComponent
} from "../component/protected-components/cr-manage-registration/cr-manage-registration-user/cr-manage-registration-user.component";
import {
    CrManageRegistrationWidgetComponent
} from "../component/protected-components/cr-manage-registration/cr-manage-registration-widget/cr-manage-registration-widget.component";
import {CrCreateUserComponent} from "../component/protected-components/eu/cr-create-user/cr-create-user.component";
import {
    CrCustomerCommentWfProcessStepActivityComponent
} from "../component/protected-components/wf/cr-customer-comment-wf-process-step-activity/cr-customer-comment-wf-process-step-activity.component";
import {
    CrCustomerPhoneAvailabilityWfProcessStepActivityComponent
} from "../component/protected-components/wf/cr-customer-phone-availability-wf-process-step-activity/cr-customer-phone-availability-wf-process-step-activity.component";
import {CustomerAssessmentPage} from "../page/customer-assessment-page/customer-assessment-page.component";
import {
    CrAssessmentComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/cr-assessment.component";
import {
    AssessmentPersonSearchComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/assessment-person-search-component/assessment-person-search.component";
import {
    CrAssessmentContractsComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-contracts/cr-assessment-contracts.component";
import {
    CrAssessmentContractsTemplateComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-contracts/components/cr-assessment-contracts-template/cr-assessment-contracts-template.component";
import {
    CrAssessmentFinaliseComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-finalise/cr-assessment-finalise.component";
import {
    CrAssessmentHouseholdComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-household/cr-assessment-household.component";
import {
    CrAssessmentInsuredObjectsComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-insured-objects/cr-assessment-insured-objects.component";
import {
    CrAssessmentPersonalInfoComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-personal-info/cr-assessment-personal-info.component";
import {
    RelationTypeTemplateComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment/components/cr-assessment-household/components/relation-type-template/relation-type-template.component";
import {
    CrAssessmentHeaderComponent
} from "../page/customer-assessment-page/components/assessment/cr-assessment-header/cr-assessment-header.component";
import {
    CrHouseholdInsuredObjectsComponent
} from "../page/customer-assessment-page/components/cr-houshlod-insured-objects/cr-household-insured-objects.component";
import {SmartGuideComponent} from "../page/customer-assessment-page/components/smart-guide/smart-guide.component";
import {CustomerKpiComponent} from "../page/customer-overview-page/components/kpiComponent/customer-kpi.component";
import {
    CustomerStatisticsComponent
} from "../page/customer-overview-page/components/statisticsComponent/customer-statistics.component";
import {
    CrAssessmentToolPanelComponent
} from "../page/customer-specific-page/components/cr-assessment-tool-panel/cr-assessment-tool-panel.component";
import {
    CrCustomerCallHistory
} from "../page/customer-specific-page/components/cr-customer-call-history/cr-customer-call-history";
import {
    CustomerContractDetailComponent
} from "../page/customer-specific-page/components/customer-contract-detail-component/customer-contract-detail.component";
import {
    CrToolPanelComponent
} from "../page/customer-specific-page/components/tool-panel-component/cr-tool-panel.component";
import {
    CustomerSpecificComponent
} from "../page/customer-specific-page/customer-specific-component/customer-specific.component";
import {CrDashboardPage} from "../page/dashboard/cr-dashboard/cr-dashboard.page";
import {CrCustomerLastPage} from "../page/object/cr-customer-last/cr-customer-last.page";
import {CrCustomerObjectPage} from "../page/object/cr-customer-object-page/cr-customer-object.page";
import {
    CustomerPersonHouseholdComponent
} from "../page/object/cr-customer-object-page/component/pm-household/customer-person-household.component";
import {CrConfigPage} from "../page/overview/cr-config/cr-config.page";
import {ConfigPage} from "../page/overview/config/config.page";
import {CrRegistrationManageComponent} from "../page/overview/cr-registration-manage/cr-registration-manage.component";
import {CustomerOnboardingTypePage} from "../page/overview/customer-onboarding-type/customer-onboarding-type.page";
import {CustomerSearchPage} from "../page/overview/customer-search/customer-search.page";
import {
    CustomerSignatureTypePagePage
} from "../page/overview/customer-signature-type-page/customer-signature-type-page.page";
import {CustomerTypePage} from "../page/overview/customer-type/customer-type.page";
import {CustomerWelcomePage} from "../page/overview/customer-welcome/customer-welcome.page";
import {
    CrSearchFlexibleCustomerComponent
} from "../search/cr-search-flexible-customer/cr-search-flexible-customer.component";
import {
    CrCustomerCommunicationNavigationConsultantComponent
} from "../component/protected-components/consultant-component/cr-customer/component/cr-customer-communication-navigation-consultant/cr-customer-communication-navigation-consultant.component";
import {
    CrCustomerHeaderConsultantComponent
} from "../component/protected-components/consultant-component/cr-customer/component/cr-customer-header-consultant/cr-customer-header-consultant.component";
import {
    CrCustomerStandardNavigationConsultantComponent
} from "../component/protected-components/consultant-component/cr-customer/component/cr-customer-standard-navigation-consultant/cr-customer-standard-navigation-consultant.component";
import {
    CrCustomerConsultantComponent
} from "../component/protected-components/consultant-component/cr-customer/cr-customer-consultant.component";
import {
    CrCustomerDocumentUploadConsultantComponent
} from "../component/protected-components/consultant-component/cr-customer-document-upload/cr-customer-document-upload-consultant.component";
import {
    CrCustomerTicketsComponent
} from "../component/protected-components/consultant-component/cr-customer-tickets/cr-customer-tickets.component";
import {
    AppDisplayDetailComponent
} from "../page/consultant-page/customer-overview-page/components/app-display-detail/app-display-detail.component";
import {
    OverviewComponent
} from "../page/consultant-page/customer-overview-page/components/overview-component/overview.component";
import {
    CustomerOverviewConsultantPage
} from "../page/consultant-page/customer-overview-page/customer-overview-consultant.page";
import {MyCustomersPage} from "../page/consultant-page/my-customers-page/my-customers.page";
import {
    CrCustomerObjectConsultantPage
} from "../page/consultant-page/object/cr-customer-object-page/cr-customer-object-consultant.page";

const crModuleEntry: TestModuleDefinition = {
    key: 'cr',
    label: 'Customer (cr)',
    components: [
        {
            key: 'CrCustomerHeader',
            component: CrCustomerHeaderComponent,
            selector: 'cr-customer-header',

            type: 'HeaderComponent',
            label: 'Customer Page Header',
        },
        {
            key: 'CrCustomerProfile',
            component: CrCustomerProfileCheckComponent,
            selector: 'cr-customer-profile-check',
            type: 'InfoComponent',
            label: 'Customer Profile Check',
        },
        {
            key: 'CrCreateCustomerDetailComponent',
            component: CrCreateCustomerDetailComponent,
            selector: 'cr-create-customer-detail',
            type: 'ObjectBaseComponent',
            label: 'Create Customer Detail',
        },
        {
            key: 'CrCreateCustomerEmergencyContactComponent',
            component: CrCreateCustomerEmergencyContactComponent,
            selector: 'cr-create-emergency-contact',
            type: 'ObjectBaseComponent',
            label: 'Create Customer Emergency Contact',
        },
        {
            key: 'CrCreateObjectCustomerComponent',
            component: CrCreateObjectCustomerComponent,
            selector: 'mvs-cr-create-object-customer',
            type: 'ObjectBaseComponent',
            label: 'Create Object Customer',
        },
        {
            key: 'CrCustomerComponent',
            component: CrCustomerComponent,
            selector: 'mvs-cr-customer',
            type: 'ObjectBaseComponent',
            label: 'Customer Component',
        },
        {
            key: 'CrCustomerAdditionalInformationNavigationComponent',
            component: CrCustomerAdditionalInformationNavigationComponent,
            selector: 'cr-customer-additional-information-navigation',
            type: 'ObjectBaseComponent',
            label: 'Customer Additional Information Navigation',
        },
        {
            key: 'CrCustomerAppointmentsComponent',
            component: CrCustomerAppointmentsComponent,
            selector: 'cr-customer-appointments',
            type: 'ObjectBaseComponent',
            label: 'Customer Appointments'
        },
        {
            key: 'CrCustomerCommunicationNavigationComponent',
            component: CrCustomerCommunicationNavigationComponent,
            selector: 'cr-customer-communication-navigation',
            type: 'ObjectSubBaseComponent',
            label: 'Customer Communication Navigation',
        },
        {
            key: 'CrCustomerExternalIdsComponent',
            component: CrCustomerExternalIdsComponent,
            selector: 'cr-customer-external-ids',
            type: 'ObjectSubBaseComponent',
            label: 'Customer External Ids',
        },
        {
            key: 'CrCustomerInteractionNavigationComponent',
            component: CrCustomerInteractionNavigationComponent,
            selector: 'cr-customer-interactions-navigation',
            type: 'ObjectSubBaseComponent',
            label: 'Customer Interaction Navigation',
        },
        {
            key: 'cr-customer-promo',
            component: CrCustomerPromoComponent,
            selector: 'cr-customer-promo',
            type: 'ObjectSubBaseComponent',
            label: 'Customer Promo',
        },
        {
            key: 'CrCustomerRegistrationNavigationComponent',
            component: CrCustomerRegistrationNavigationComponent,
            selector: 'cr-customer-registration-navigation',
            type: 'ObjectSubBaseComponent',
            label: 'Customer Registration Navigation',
        },
        {
            key: 'CrCustomerStandardNavigationComponent',
            component: CrCustomerStandardNavigationComponent,
            selector: 'cr-customer-standard-navigation',
            type: 'ObjectSubBaseComponent',
            label: 'Customer Standard Navigation',
        },
        {
            key: 'CrCustomerCommentsComponent',
            component: CrCustomerCommentsComponent,
            selector: 'cr-customer-comments',
            type: 'ObjectBaseComponent',
            label: 'Customer Comments',
        },
        {
            key: 'CrCustomerContractDetailsComponent',
            component: CrCustomerContractDetailsComponent,
            selector: 'cr-customer-contracts-details',
            type: 'Component',
            label: 'Customer Contract Details',
        },
        {
            key: 'CrCustomerDocumentUploadComponent',
            component: CrCustomerDocumentUploadComponent,
            selector: 'cr-customer-document-upload',
            type: 'Component',
            label: 'Customer Document Upload',
        },
        {
            key: 'CrCustomerInlineComponent',
            component: CrCustomerInlineComponent,
            selector: 'cr-customer-inline-component',
            type: 'Component',
            label: 'Customer Inline Component',
        },
        {
            key: 'CrCustomerInteractionInlineComponent',
            component: CrCustomerInteractionInlineComponent,
            selector: 'cr-customer-interaction-inline-component',
            type: 'Component',
            label: 'Customer Interaction Inline Component',
        },
        {
            key: 'CrCustomerInteractionObjectComponent',
            component: CrCustomerInteractionObjectComponent,
            selector: 'cr-customer-interaction-object-component',
            type: 'Component',
            label: 'Customer Interaction Object Component',
        },
        {
            key: 'CrCustomerPhoneContactAvailabilityComponent',
            component: CrCustomerPhoneContactAvailabilityComponent,
            selector: 'mvs-cr-customer-phone-contact-availability',
            type: 'ObjectBaseComponent',
            label: 'Customer Phone Contact Availability',
        },
        {
            key: 'CrCustomerRelatedPersonComponent',
            component: CrCustomerRelatedPersonComponent,
            selector: 'cr-customer-related-person',
            type: 'ObjectBaseComponent',
            label: 'Customer Related Person',
        },
        {
            key: 'CrManageRegistrationDocumentComponent',
            component: CrManageRegistrationDocumentComponent,
            selector: 'cr-manage-registration-document',
            type: 'Component',
            label: 'Customer Registration Document',
        },
        {
            key: 'CrRegistrationToolingTicketViewerComponent',
            component: CrRegistrationToolingTicketViewerComponent,
            selector: 'cr-registration-tooling-ticket-viewer',
            type: 'Component',
            label: 'Customer Tooling Ticket Viewer',
        },
        {
            key: 'CrManageRegistrationToolingAreaComponent',
            component: CrManageRegistrationToolingAreaComponent,
            selector: 'cr-manage-registration-tooling-area',
            type: 'Component',
            label: 'Customer Tooling Area',
        },
        {
            key: 'CrManageRegistrationUserComponent',
            component: CrManageRegistrationUserComponent,
            selector: 'cr-manage-registration-user',
            type: 'PageComponent',
            label: 'Customer Manage Registration',
        },
        {
            key: 'CrManageRegistrationWidgetComponent',
            component: CrManageRegistrationWidgetComponent,
            selector: 'cr-manage-registration-widget',
            type: 'Component',
            label: 'Customer Registration Widget',
        },
        {
            key: 'CrCreateUserComponent',
            component: CrCreateUserComponent,
            selector: 'cr-create-user',
            type: 'Component',
            label: 'Create User',
        },
        {
            key: 'CrCustomerCommentWfProcessStepActivityComponent',
            component: CrCustomerCommentWfProcessStepActivityComponent,
            selector: 'mvs-wf-process-step-activity-object-customer-comment',
            type: 'Component',
            label: 'Customer Comment WorkFlow Process',
        },
        {
            key: 'CrCustomerPhoneAvailabilityWfProcessStepActivityComponent',
            component: CrCustomerPhoneAvailabilityWfProcessStepActivityComponent,
            selector: 'mvs-wf-process-step-activity-object-customer-phone-contact-availability',
            type: 'Component',
            label: 'Customer Phone Availability',
        },
        {
            key: 'CustomerAssessmentPage',
            component: CustomerAssessmentPage,
            selector: 'customer-assessment-page',
            type: 'ObjectPageComponent',
            label: 'Customer Assessment Page',
        },
        {
            key: 'CrAssessmentComponent',
            component: CrAssessmentComponent,
            selector: 'cr-assessment',
            type: 'PageComponent',
            label: 'Customer Assessment ',
        },
        {
            key: 'AssessmentPersonSearchComponent',
            component: AssessmentPersonSearchComponent,
            selector: 'assessment-person-search',
            type: 'Component',
            label: 'Assessment Person Search'
        },
        {
            key: 'CrAssessmentContractsComponent',
            component: CrAssessmentContractsComponent,
            selector: 'cr-assessment-contracts',
            type: 'Component',
            label: 'Customer Assessment Contracts',
        },
        {
            key: 'CrAssessmentContractsTemplateComponent',
            component: CrAssessmentContractsTemplateComponent,
            selector: 'cr-assessment-contracts-template',
            type: 'Component',
            label: 'Customer Assessment Template',
        },
        {
            key: 'CrAssessmentFinaliseComponent',
            component: CrAssessmentFinaliseComponent,
            selector: 'cr-assessment-finalise',
            type: 'Component',
            label: 'Customer Assessment Finalise',
        },
        {
            key: 'CrAssessmentHouseholdComponent',
            component: CrAssessmentHouseholdComponent,
            selector: 'cr-assessment-household',
            type: 'Component',
            label: 'Customer Assessment Household',
        },
        {
            key: 'CrAssessmentInsuredObjectsComponent',
            component: CrAssessmentInsuredObjectsComponent,
            selector: 'cr-assessment-insured-objects',
            type: 'Component',
            label: 'Customer Assessment Insured Objects',
        },
        {
            key: 'CrAssessmentPersonalInfoComponent',
            component: CrAssessmentPersonalInfoComponent,
            selector: 'cr-assessment-personal-info',
            type: 'Component',
            label: 'Customer Assessment Personal Info',
        },
        {
            key: 'RelationTypeTemplateComponent',
            component: RelationTypeTemplateComponent,
            selector: 'relation-type-template',
            type: 'Component',
            label: 'Relation Type Template',
        },
        {
            key: 'CrAssessmentHeaderComponent',
            component: CrAssessmentHeaderComponent,
            selector: 'cr-assessment-header',
            type: 'Component',
            label: 'Customer Assessment Header',
        },
        {
            key: 'CrHouseholdInsuredObjectsComponent',
            component: CrHouseholdInsuredObjectsComponent,
            selector: 'cr-assessment-insured-objects',
            type: 'Component',
            label: 'Customer Household Insured Objects',
        },
        {
            key: 'SmartGuideComponent',
            component: SmartGuideComponent,
            selector: 'smart-guide',
            type: 'Component',
            label: 'smart Guide',
        },
        {
            key: 'CustomerKpiComponent',
            component: CustomerKpiComponent,
            selector: 'customer-kpi',
            type: 'Component',
            label: 'Customer Kpi',
        },
        {
            key: 'CustomerStatisticsComponent',
            component: CustomerStatisticsComponent,
            selector: 'customer-statistics',
            type: 'Component',
            label: 'Customer Statistics',
        },
        {
            key: 'CrAssessmentToolPanelComponent',
            component: CrAssessmentToolPanelComponent,
            selector: 'cr-assessment-tool-panel',
            type: 'Component',
            label: 'Customer Assessment Tool Panel',
        },
        {
            key: 'CrCustomerCallHistory',
            component: CrCustomerCallHistory,
            selector: 'cr-assessment-call-history',
            type: 'Component',
            label: 'Customer Call History',
        },
        {
            key: 'CustomerContractDetailComponent',
            component: CustomerContractDetailComponent,
            selector: 'cr-customer-contract-detail',
            type: 'Component',
            label: 'Customer Contract Detail',
        },
        {
            key: 'CrToolPanelComponent',
            component: CrToolPanelComponent,
            selector: 'cr-tool-panel',
            type: 'Component',
            label: 'Customer Tool Panel',
        },
        {
            key: 'CustomerSpecificComponent',
            component: CustomerSpecificComponent,
            selector: 'cr-customer-specific-component',
            type: 'Component',
            label: 'Customer Specific Component',
        },
        {
            key: 'CrDashboardPage',
            component: CrDashboardPage,
            selector: 'mvs-cr-dashboard-page',
            type: 'PageComponent',
            label: 'Customer Dashboard',
        },
        {
            key: 'CrCustomerLastPage',
            component: CrCustomerLastPage,
            selector: 'mvs-cr-customer-last-page',
            type: 'PageComponent',
            label: 'Customer Last Page',
        },
        {
            key: 'CrCustomerObjectPage',
            component: CrCustomerObjectPage,
            selector: 'mvs-cr-customer-object-page',
            type: 'ObjectPageComponent',
            label: 'Customer Object Component',
        },
        {
            key: 'CustomerPersonHouseholdComponent',
            component: CustomerPersonHouseholdComponent,
            selector: 'customer-person-household-persons',
            type: 'Component',
            label: 'Customer Person Household Persons',
        },
        {
            key: 'ConfigPage',
            component: ConfigPage,
            selector: 'mvs-cr-contact-page',
            type: 'PageComponent',
            label: 'Config Page',
        },
        {
            key: 'CrConfigPage',
            component: CrConfigPage,
            selector: 'mvs-cr-config',
            type: 'PageComponent',
            label: 'Customer Config Page',
        },
        {
            key: 'CrRegistrationManageComponent',
            component: CrRegistrationManageComponent,
            selector: 'cr-registration-manage',
            type: 'PageComponent',
            label: 'Customer Registration Manage Page'
        },
        {
            key: 'CustomerOnboardingTypePage',
            component: CustomerOnboardingTypePage,
            selector: 'mvs-cr-customer-onboarding-type-page',
            type: 'PageComponent',
            label: 'Customer Onboarding Type Page',
        },
        {
            key: 'CustomerSearchPage',
            component: CustomerSearchPage,
            selector: 'cr-customer-search',
            type: 'PageComponent',
            label: 'Customer Search Page',
        },
        {
            key: 'CustomerSignatureTypePagePage',
            component: CustomerSignatureTypePagePage,
            selector: 'mvs-cr-customer-signature-type-page',
            type: 'PageComponent',
            label: 'Customer Signature Type Page',
        },
        {
            key: 'CustomerTypePage',
            component: CustomerTypePage,
            selector: 'mvs-cr-contact-page',
            type: 'PageComponent',
            label: 'Customer Type Page',
        },
        {
            key: 'CustomerWelcomePage',
            component: CustomerWelcomePage,
            selector: 'mvs-cr-contact-page',
            type: 'PageComponent',
            label: 'Customer Welcome Page',
        },
        {
            key: 'CrSearchFlexibleCustomerComponent',
            component: CrSearchFlexibleCustomerComponent,
            selector: 'cr-search-flexible-customer',
            type: 'Component',
            label: 'Customer Search Component',
        },
    //     CONSULTANT
        {
            key: 'CrCustomerCommunicationNavigationConsultantComponent',
            component: CrCustomerCommunicationNavigationConsultantComponent,
            selector: 'cr-customer-communication-navigation-consultant',
            type: 'CrCustomerCommunicationNavigationComponent',
            label: 'cr customer communication navigation consultant component'
        },
        {
            key: 'CrCustomerHeaderConsultantComponent',
            component: CrCustomerHeaderConsultantComponent,
            selector: 'cr-customer-header-consultant',
            type: 'Component',
            label: 'cr customer header consultant component'
        },
        {
            key: 'CrCustomerStandardNavigationConsultantComponent',
            component: CrCustomerStandardNavigationConsultantComponent,
            selector: 'cr-customer-standard-navigation-consultant',
            type: 'ObjectSubBaseComponent',
            label: 'cr customer standard navigation consultant component'
        },
        {
            key: 'CrCustomerConsultantComponent',
            component: CrCustomerConsultantComponent,
            selector: 'mvs-cr-customer-consultant',
            type: 'ObjectBaseComponent',
            label: 'cr customer consultant component'
        },
        {
            key: 'CrCustomerDocumentUploadConsultantComponent',
            component: CrCustomerDocumentUploadConsultantComponent,
            selector: 'cr-customer-document-upload-consultant',
            type: 'CrCustomerDocumentUploadComponent',
            label: 'cr customer document upload consultant component'
        },
        {
            key: 'CrCustomerTicketsComponent',
            component: CrCustomerTicketsComponent,
            selector: 'cr-customer-tickets',
            type: 'Component',
            label: 'cr customer tickets component consultant'
        },
        {
            key: 'AppDisplayDetailComponent',
            component: AppDisplayDetailComponent,
            selector: 'app-display-detail',
            type: 'Component',
            label: 'app display detail component consultant'
        },
        {
            key: 'OverviewComponent',
            component: OverviewComponent,
            selector: 'overview-component',
            type: 'Component',
            label: 'overview component consultant'
        },
        {
            key: 'CustomerOverviewConsultantPage',
            component: CustomerOverviewConsultantPage,
            selector: 'mvs-customer-overview-page',
            type: 'ObjectPageComponent',
            label: 'customer overview consultant page'
        },
        {
            key: 'MyCustomersPage',
            component: MyCustomersPage,
            selector: 'cr-my-customers',
            type: 'CorePage',
            label: 'my customers page consultant'
        },
        {
            key: 'CrCustomerObjectConsultantPage',
            component: CrCustomerObjectConsultantPage,
            selector: 'mvs-cr-customer-object-consultant-page',
            type: 'ObjectPageComponent',
            label: 'cr customer object consultant page'
        },

    ]
};

export const CR_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: crModuleEntry, multi: true }
];
